<template>
    <!--头部-->
    <div class="header">
        <div class="top">
            <div class="after">
                <span class="fl">{{$t("welcome")}}</span>
                <div class="fr">
                  <!-- <a href="/" class="colorred"><i class="telbtn"></i>客服中心：999999</a>| -->
                  <a href="#">{{$t("business_outlets")}}</a>|
                  <!-- <a href="#">友情链接</a> -->
                  <ul class="pubnav fr after" style="padding-left: 0px;">
                    <li>
                      <a href="#" style="font-size: 12px !important; margin-left: -30px !important">{{$t("links")}}</a>
                      <div class="navList after" style="width: 150px;top: 38px  !important">
                        <dl style="width: 150px;">
                          <dt><a :href="ase_url" style="font-size: 12px;">{{$t("ase")}}</a></dt>
                        </dl>
                      </div>
                    </li>
                  </ul>

                </div>
            </div>
        </div>
        <div class="nav">
            <div class="navOut after">
                <a href="/" class="fl logo">
                  <img :src="logo_url" alt="塔吉克证券"/>
                </a>
                <ul class="pubnav fr after">
                    <li>
                        <a href="/">{{$t("home")}}</a>
                    </li>

                    <li>
                        <a href="#">{{$t("about_us")}}</a>

                        <div class="navList after" style="width: 100%">
                            <dl>
                              <dt><a href="/company_introductions">{{$t("company_introductions")}}</a></dt>
                            </dl>
                            <dl>
                              <dt><a href="/company_culture">{{$t("company_culture")}}</a></dt>
                            </dl>
                            <dl>
                              <dt><a href="/organization">{{$t("company_organization")}}</a></dt>
                            </dl>
                            <dl>
                              <dt><a href="/contact_us">{{$t("contact_us")}}</a></dt>
                            </dl>
                        </div>
                    </li>


                    <li>
                        <a href="#">{{$t("business_introductions")}}</a>
                        <div class="navList after" style="width: 100%">
                            <dl>
                                <dt><a href="/personal_business">{{$t("personal_business")}}</a></dt>
                            </dl>
                            <dl>
                                <dt><a href="/agency_business">{{$t("institutional_business")}}</a></dt>
                            </dl>
                        </div>
                    </li>
                    <li>
                        <a href="/news">{{$t("news_center")}}</a>

                    </li>

                    <li>
                        <a href="/download_app">{{$t("app_download")}}</a>
                    </li>

                    <li>
                        <a :href="signUrl" target="_blank">{{$t("sign_up")}}</a>
                    </li>

                    <li>
                        <a :href="www_url" target="_blank">{{$t("trading_online")}}</a>
                    </li>

                    <li>
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                          <img :src="currentLanguageImg" style="margin-bottom: -6px;height: 25px;" />
                          {{currentLanguage}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="margin-top: -20px">
                          <el-dropdown-item v-for="item in languageData">
                            <div @click="changeLanguage(item.label)" style="height: 40px;line-height: 40px;">
                              <img :src="item.img_url" style="margin-bottom: -6px;margin-right: 8px;height: 25px;" />
                              <span>{{item.name}}</span>
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </li>

                </ul>
            </div>
        </div>
    </div>
    <!--头部结束-->
</template>

<script>
  import Vue from 'vue'
  import {zh_logo_url,en_logo_url, ru_logo_url, zh_img_url, en_img_url, ru_img_url} from '../application'
  export default {
      data() {
          return {
              languageData:[
                {
                  label:'ru',
                  name:'русский',
                  img_url: ru_img_url
                },
                {
                  label:'en',
                  name:'English',
                  img_url: en_img_url
                },
                {
                  label:'zh',
                  name:'简体中文',
                  img_url: zh_img_url
                }
              ],
              signUrl: '',
              www_url: "",
              ase_url: ""
          }
      },
      name: "Header",
      methods: {
          changeLanguage(lang) {
              localStorage.setItem("lang", lang)
              Vue.setStorageVariable({'lang':lang});
              this.$router.go(0)
          }
      },
    computed:{
      lang: function () {
        return this.currentLang || 'zh';
      },
      currentLanguageImg: function() {
        let lang = this.currentLang || 'zh'
        if(lang == 'zh'){
          return zh_img_url
        }else if(lang == 'en'){
            return en_img_url
        }else if(lang == 'ru'){
            return ru_img_url
        }else{
            return en_img_url;
        }
      },
      currentLanguage: function () {
        let lang = this.currentLang || 'zh'
        if(lang == 'zh'){
          return "简体中文"
        }else if(lang == 'en'){
            return "English"
        }else if(lang == 'ru'){
            return "русский"
        }else if(lang == 'jp'){
            return "日本語"
        }else if(lang == 'kr'){
            return "한국어"
        }else{
            return "English";
        }
      },
      logo_url:function () {
        let lang = this.currentLang || 'zh'
        if(lang ==='zh'){
          return zh_logo_url
        }else if(lang ==='en'){
          return en_logo_url
        }else{
          return ru_logo_url
        }
      }
    },
    mounted() {
      let lang = this.currentLang || 'zh'
      this.signUrl = Vue.getValueByKey('cas_path')+'/sign_up?service=' + window.location.href.split('?')[0] + '&lang=' + this.currentLang;
      this.www_url = this.loginUrl = Vue.getValueByKey('www_path') + '?lang=' + this.currentLang;
      this.ase_url = Vue.getValueByKey('ase_path') + '?lang=' + this.currentLang;
    }
  }
</script>

<style scoped>
    .el-dropdown-link {
        cursor: pointer;
        color: #107ac1;
        font-size: 16px
    }
</style>